/**
 * Angular library starter
 * Build an Angular library compatible with AoT compilation & Tree shaking like an official package
 * Copyright Roberto Simonetti
 * MIT license
 * https://github.com/robisim74/ngx-spellchecker
 */

/**
 * Entry point for all public APIs of the package.
 */
export * from './src/ngx-spellchecker';

// This file only reexports content of the `src` folder. Keep it that way.
